import React from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

interface TooltipOptionProps {
	onExportPDF?: () => void;
	onExportExcel?: () => void;
}

const TooltipOption: React.FC<TooltipOptionProps> = ({
	onExportPDF,
	onExportExcel,
}) => {
	return (
		<>
		{/* Refresh and Print icon */}
		
			<div className="dropdown me-2 mb-2">
				<Link
					to="#"
					className="dropdown-toggle btn btn-light fw-medium d-inline-flex align-items-center btn-outline-primary"
					data-bs-toggle="dropdown"
				>
					<i className="ti ti-file-export me-2" />
					Export
				</Link>
				<ul className="dropdown-menu  dropdown-menu-end p-3">
					<li>
						<button
							type="button"
							className="dropdown-item rounded-1"
							onClick={onExportPDF}
							// disabled={!onExportPDF}
						>
							<i className="ti ti-file-type-pdf me-1" />
							Export as PDF
						
						</button>
					</li>
					<li>
						<button
							type="button"
							className="dropdown-item rounded-1"
							onClick={onExportExcel}
							// disabled={!onExportExcel}
						>
							<i className="ti ti-file-type-xls me-1" />
							Export as Excel{" "}
							
						</button>
					</li>
				</ul>
			</div>
		</>
	);
};

export default TooltipOption;
